import { create } from "zustand";

export interface AuthTokenClaims {
  aud: string[] | string;
  azp?: string;
  customer_id?: string;
  exp?: number;
  iat?: number;
  iss?: string;
  permissions?: string[];
  scope?: string;
  sg_customer_id?: string;
  sub: string;
}

interface AuthClaimsState {
  claims?: AuthTokenClaims;
  setClaims: (claims?: AuthTokenClaims) => void;
}

export const useAuthClaimsStore = create<AuthClaimsState>(set => ({
  claims: undefined,
  setClaims: claims => set(() => ({ claims })),
}));

export default useAuthClaimsStore;
